<template>
  <div class="payment-wrapper">
    <validation-observer ref="formRules">
      <div class="payment-card">
        <h2 class="title">Secure Payment Gateway</h2>

        <!-- Customer Type Selection -->
        <b-form-group style="text-align: left">
          <label
            ><strong>Recharge Amount</strong
            ><span style="color: red">*</span></label
          >
          <validation-provider
            #default="{ errors }"
            name="Recharge Amount"
            rules="required"
          >
            <input
              v-model.number="amount"
              placeholder="Enter Amount (BDT)"
              type="number"
              class="amount-input"
              style="margin-bottom: 0"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <div class="gateway-selection">
          <label class="gateway-option">
            <input type="radio" value="bkash" v-model="gateway" />
            <img src="/images/bkash_payment_logo.png" alt="bKash" />
          </label>
          <label class="gateway-option">
            <input type="radio" value="nagad" v-model="gateway" />
            <img src="/images/nagad_payment_logo.png" alt="Nagad" />
          </label>
          <label class="gateway-option">
            <input type="radio" value="sslcommerz" v-model="gateway" />
            <img src="/images/ssl-commerz-payment-logo.png" alt="SSLCommerz" />
          </label>
        </div>

        <button @click="startPayment" :disabled="loading" :class="gateway">
          {{ loading ? "Processing..." : `Pay with ${gatewayLabel}` }}
        </button>
      </div>
    </validation-observer>
    <!-- Video Card -->
    <div class="row mt-4">
      <div class="col-12 col-lg-12">
        <b-card>
          <div class="md">
            <h3 class="mt-10">How to Pay for MiME Internet from Selfcare</h3>
            <video class="col-12 col-lg-6" width="600" controls>
              <source :src="videoUrl" type="video/mp4" />
            </video>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import { BFormGroup, BCard } from "bootstrap-vue";
import api from "@/services/api";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import vSelect from "vue-select";
import { required } from "vee-validate/dist/rules";
import { decrypt } from "@/utils/crypto";

extend("required", required);
export default {
  name: "PaymentGateway",
  components: {
    vSelect,
    BFormGroup,
    BCard,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      amount: "",
      gateway: "bkash",
      loading: false,
      method: "create-payment",
      loadingCustomers: false,
      username: "",
      videoUrl: "/documents/How_to_Pay_for_MiME_Internet_from_Selfcare.mp4",
    };
  },
  mounted() {
    this.setUsernameFromLocalStorage();
  },
  computed: {
    gatewayLabel() {
      const map = {
        bkash: "bKash",
        nagad: "Nagad",
        sslcommerz: "SSLCommerz",
      };
      return map[this.gateway] || "Gateway";
    },
  },
  methods: {
    setUsernameFromLocalStorage() {
      try {
        const userData = decrypt(localStorage.getItem("userData"));
        if (userData && typeof userData.username === "string") {
          this.username = userData.username.trim();
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Warning!",
            text: "User session invalid. Please log in again.",
            error,
            icon: "AlertTriangleIcon",
            variant: "danger",
            duration: 4000,
          },
        });
        this.$router.push("/login");
      }
    },

    async startPayment() {
      const formRules = this.$refs.formRules;
      const isValid = await formRules.validate();

      if (!isValid) {
        return;
      }

      if (!this.amount || parseFloat(this.amount) < 10) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            text: "Enter a valid amount (minimum 10 BDT).",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return;
      }
      this.loading = true;
      try {
        const userId = this.username;

        if (this.gateway === "nagad") {
          const response = await api.post(`/api/nagad_pw/process-payment/`, {
            unique_user_id: userId,
            invoice_number: `${this.generateInvoiceNumber()}`,
            amount: this.amount,
            redirect_source_site: window.location.origin,
            merchant_callback_url: `${window.location.origin}/nagad/payment-status`,
          });
          const res = response.data;
          const redirectURL = res.data.payment_url || "";
          const paymentID = res.data.payment_reference_id || "";
          const success = res.success || false;

          if (!paymentID || !redirectURL || !success)
            throw new Error(res.data.error || "Payment initiation failed");

          window.location.href = redirectURL;
        } else if (this.gateway === "sslcommerz") {
          let payload = {
            amount: this.amount,
            unique_user_id: userId,
            currency: "BDT",
            customer_address: "Dhaka, Bangladesh",
            customer_city: "Dhaka",
            customer_country: "Bangladesh",
            product_name: "Internet Package",
            product_category: "Service",
            redirect_source_site: window.location.origin,
            // success_url: `https://testgateway.mimebd.com/api/ssl_commerz/payment/callback/`,
            // fail_url: `https://testgateway.mimebd.com/api/ssl_commerz/payment/callback/`,
            // cancel_url: `https://testgateway.mimebd.com/api/ssl_commerz/payment/callback/`,
            // ipn_url: `https://testgateway.mimebd.com/api/ssl_commerze/ipn/`,
          };
          const response = await api.post(
            `/api/ssl_commerz/payment/init/`,
            payload,
          );

          const res = response.data;
          const paymentID = res.transaction_id || "";
          const redirectURL = res.gateway_url || false;
          const success = res.success || false;

          if (!paymentID || !redirectURL || !success)
            throw new Error(res.data.error || "Payment initiation failed");

          window.location.href = redirectURL;
        } else {
          const response = await api.post(`/api/bkash_pw/create-payment-new/`, {
            merchant_invoice_number: this.generateInvoiceNumber(),
            amount: this.amount,
            intent: "sale",
            mode: "0011",
            payer_reference: userId,
            redirect_source_site: window.location.origin,
            callback_url: window.location.origin + "/bkash/payment-status",
          });

          const res = response.data;
          const paymentID = res.payment_id || "";
          const redirectURL = res.bkash_url || false;
          const success = res.success || false;

          if (!paymentID || !redirectURL || !success)
            throw new Error(res.data.error || "Payment initiation failed");

          window.location.href = redirectURL;
        }
      } catch (err) {
        console.error("Error:", err);
        const errorMessage =
          err?.response?.data?.message ||
          err.message ||
          "Something went wrong!";

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            text: errorMessage,
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      } finally {
        this.loading = false;
      }
    },
    generateInvoiceNumber() {
      const prefix = "INV";
      const randomPart = Math.random().toString(36).substr(2, 12).toUpperCase();
      const invoiceNumber = (prefix + randomPart).substr(0, 20); // Trim if exceeds 20
      return invoiceNumber;
    },
  },
};
</script>
<style scoped>
* {
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden; /* Prevent scroll */
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.payment-wrapper {
  display: flex;
  flex-direction: column; /* ADD THIS */
  align-items: center;
  /* height: 100vh;
    width: 100vw; */
  background: #f0f2f5;
  padding: 16px;
}

.payment-card {
  background: #ffffff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
  text-align: center;
}

.title {
  margin-bottom: 16px;
  font-size: 20px;
  color: #333;
}

.amount-input {
  padding: 6px 10px;
  width: 100%;
  border-radius: 6px;
  border: 1px solid #ccc;
  margin-bottom: 20px;
  font-size: 16px;
}
.gateway-selection {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
  margin-bottom: 20px;
}

.gateway-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100px;
  cursor: pointer;
  border: 2px solid transparent;
  padding: 8px;
  border-radius: 8px;
  transition: all 0.3s ease;
  background-color: #f9f9f9;
}

.gateway-option:hover,
.gateway-option input:checked + img {
  border-color: #007bff;
}

.gateway-option img {
  width: 100%;
  max-width: 80px;
  height: auto;
  object-fit: contain;
  border-radius: 4px;
  margin-top: 5px;
}

@media (max-width: 480px) {
  .gateway-option {
    width: 30%;
    max-width: 100px;
  }
}

button {
  width: 100%;
  padding: 12px;
  font-size: 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.bkash {
  background-color: #d22165;
  color: #fff;
  border: none;
}

.nagad {
  background-color: #ff0010;
  color: #fff;
  border: none;
}

.sslcommerz {
  background-color: #2055a7;
  color: #fff;
  border: none;
}

button:disabled {
  background-color: #ccc !important;
  cursor: not-allowed;
}

.status-text {
  margin-top: 15px;
  font-size: 14px;
  color: #444;
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
